// OUR MODULES
import RequestRabbit from './RequestRabbit';

// CONFIG
import config from '../Config';

const useComplianceRequest = () => {
  /*
  New functionality for the addressbook
  */
  const getCampaignManagementIssues = async (errorHandler, searchValue) => {
    try {
      let url = `${config.baseServerURL}/admin/campaign-management/issues`;
      if (searchValue) {
        url += `?searchValue=${searchValue}`;
      }

      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const getCampaignManagementTrial = async (errorHandler, searchValue) => {
    try {
      let url = `${config.baseServerURL}/admin/campaign-management/trial`;
      if (searchValue) {
        url += `?searchValue=${searchValue}`;
      }

      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const getCampaignManagementRegular = async (errorHandler, searchValue) => {
    try {
      let url = `${config.baseServerURL}/admin/campaign-management/regular`;
      if (searchValue) {
        url += `?searchValue=${searchValue}`;
      }

      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const getBrand = async (id, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/${id}`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const updateBrand = async (id, updateData, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/${id}`;
      const body = JSON.stringify(updateData);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'PUT',
        body: body,
        headers: headers,
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      return response.status === 200;
    } catch (err) {
      errorHandler(err);
    }
  };

  const updateBrandCustomers = async (id, updateData, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/${id}/customers`;
      const body = JSON.stringify(updateData);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'PUT',
        body: body,
        headers: headers,
      };

      await RequestRabbit.request(url, options, errorHandler);
    } catch (err) {
      errorHandler(err);
    }
  };

  const revetBrand = async (id, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/revet/${id}`;
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'PUT',
        headers: headers,
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };
  const getBrandUseCase = async (brandCode, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/usecase?brandCode=${brandCode}`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const getBrandFeedback = async (brandCode, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/feedback?brandCode=${brandCode}`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const getVettingReport = async (brandCode, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/vetting-report?brandCode=${brandCode}`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const getCampaign = async (id, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/campaign/${id}`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const createCampaign = async (campaignData, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/campaign`;
      const body = JSON.stringify(campaignData);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        body: body,
        headers: headers,
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const updateCampaign = async (campaignId, campaignData, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/campaign/${campaignId}`;
      const body = JSON.stringify(campaignData);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'PUT',
        body: body,
        headers: headers,
      };

      await RequestRabbit.request(url, options, errorHandler);
    } catch (err) {
      errorHandler(err);
    }
  };

  const getOptions = async (names, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/options?names=${names}`;
      const body = JSON.stringify(name);
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const getCustomerAccounts = async (brandId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/customer-accounts?brandId=${brandId}`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const getAppeals = async (brandId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/${brandId}/appeal`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const createAppeal = async (brandId, appealData, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/${brandId}/appeal`;
      const body = JSON.stringify(appealData);
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        body: body,
        headers: headers,
      };

      await RequestRabbit.request(url, options, errorHandler);
    } catch (err) {
      errorHandler(err);
    }
  };

  const getAppealEvidence = async (brandId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/${brandId}/appeal/evidence`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const uploadAppealEvidence = async (brandId, file, errorHandler) => {
    try {
      const formData = new FormData();
      formData.set('file', file);

      const url = `${config.baseServerURL}/admin/campaign-management/brand/${brandId}/appeal/evidence`;
      const headers = new Headers({
        'Content-Type': 'application/json',
      });
      const options = {
        method: 'POST',
        body: formData,
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      const responseJSON = await response?.json();
      if (response?.status > 399 && response?.status < 600) {
        errorHandler(responseJSON.error);
      }

      return responseJSON;
    } catch (err) {
      errorHandler(err);
    }
  };

  const deleteAppealEvidence = async (brandId, evidenceId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/${brandId}/appeal/evidence`;

      const options = {
        method: 'DELETE',
        body: evidenceId,
      };

      await RequestRabbit.request(url, options, errorHandler);
    } catch (err) {
      errorHandler(err);
    }
  };

  const resend2Fa = async (brandId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/campaign-management/brand/${brandId}/resend-2fa`;

      const options = {
        method: 'GET',
      };

      await RequestRabbit.request(url, options, errorHandler);
    } catch (err) {
      errorHandler(err);
    }
  };

  // Export functions as a module
  return {
    getCampaignManagementIssues,
    getCampaignManagementTrial,
    getCampaignManagementRegular,
    getBrand,
    updateBrand,
    updateBrandCustomers,
    revetBrand,
    getBrandUseCase,
    getBrandFeedback,
    getVettingReport,
    getCampaign,
    createCampaign,
    updateCampaign,
    getOptions,
    getCustomerAccounts,
    getAppeals,
    createAppeal,
    getAppealEvidence,
    uploadAppealEvidence,
    deleteAppealEvidence,
    resend2Fa,
  };
};
export default useComplianceRequest;
